var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDragicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 9.06061C4 8.64221 4.34822 8.30303 4.77778 8.30303H17.2222C17.6518 8.30303 18 8.64221 18 9.06061V9.81818C18 10.2366 17.6518 10.5758 17.2222 10.5758H4.77778C4.34822 10.5758 4 10.2366 4 9.81818V9.06061Z",
    fill: "#818EA3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 12.8485C4 12.4301 4.34822 12.0909 4.77778 12.0909H17.2222C17.6518 12.0909 18 12.4301 18 12.8485V13.6061C18 14.0245 17.6518 14.3636 17.2222 14.3636H4.77778C4.34822 14.3636 4 14.0245 4 13.6061V12.8485Z",
    fill: "#818EA3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3264 3.37879C10.6258 2.87374 11.3742 2.87374 11.6736 3.37879L13.0207 5.65152C13.3201 6.15657 12.9459 6.78788 12.3472 6.78788H9.65285C9.05412 6.78788 8.67991 6.15657 8.97927 5.65152L10.3264 3.37879Z",
    fill: "#818EA3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6736 19.2879C11.3742 19.7929 10.6258 19.7929 10.3264 19.2879L8.97927 17.0152C8.67991 16.5101 9.05412 15.8788 9.65285 15.8788H12.3472C12.9459 15.8788 13.3201 16.5101 13.0207 17.0152L11.6736 19.2879Z",
    fill: "#818EA3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDragicon);
export default __webpack_public_path__ + "static/media/dragicon.75ee16e0eb1071bf54cbeac612ca536e.svg";
export { ForwardRef as ReactComponent };